import React, { useEffect, useState } from "react";
import SearchIcon from "../../assets/images/png/search-icon.svg";
import ClearIcon from "../../assets/images/png/clear-icon.svg";

const ProductFilter = ({
  data,
  minPrice,
  maxPrice,
  adType,
  onMinPriceChange,
  onMaxPriceChange,
  onAdTypeChange,
}) => {
  const [salesCount, setSalesCount] = useState(0);
  const [rentCount, setRentCount] = useState(0);
  const [leaseCount, setLeaseCount] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  console.log("data in filter-->", data);
  useEffect(() => {
    const sales = data?.filter((product) => product.adType === "sales").length;
    const rent = data?.filter((product) => product.adType === "rental").length;
    const lease = data?.filter((product) => product.adType === "lease").length;

    setSalesCount(sales);
    setRentCount(rent);
    setLeaseCount(lease);
  }, [data]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(value);
  };

  const clearFilterByType = () => {
    onAdTypeChange("");
    document.querySelectorAll('input[name="adType"]').forEach((radio) => {
      radio.checked = false;
    });
  };
  return (
    <div className="filter-panel">
      <div className="filter-header">
        <h2>Filters</h2>
        <button onClick={clearFilterByType} className="clear-all">
          Clear All
        </button>
      </div>

      <div className="filter-group">
        <h3>Filter by Price</h3>
        <div className="price-display">
          <span>Min: {formatCurrency(minPrice)}</span>
          <span>Max: {formatCurrency(maxPrice)}</span>
        </div>
        <div className="slider-container">
          <div className="slider-track"></div>
          <div className="slider-range" id="slider-range"></div>
          <div className="price-slider">
            <input
              type="range"
              id="min-price"
              min="0"
              max="10000000"
              value={minPrice}
              step="10000"
              onChange={(e) => onMinPriceChange(e.target.value)}
            />
            <input
              type="range"
              id="max-price"
              min="0"
              max="10000000"
              value={maxPrice}
              step="10000"
              onChange={(e) => onMaxPriceChange(e.target.value)}
            />
          </div>
        </div>

        <div className="filter-group">
          <h3>Filter by Type</h3>
          <div className="type-filter-list">
            <label className="type-item">
              <input
                type="radio"
                name="filter-type"
                value="sales"
                checked={adType === "sales"}
                onChange={(e) => onAdTypeChange(e.target.value)}
              />
              <span className="custom-radio"></span>
              <span className="type-tag sales">Sales</span>
              <span className="type-count">({salesCount})</span>
            </label>
            <label className="type-item">
              <input
                type="radio"
                name="filter-type"
                value="lease"
                checked={adType === "lease"}
                onChange={(e) => onAdTypeChange(e.target.value)}
              />
              <span className="custom-radio"></span>
              <span className="type-tag lease">Lease</span>
              <span className="type-count">({leaseCount})</span>
            </label>
            <label className="type-item">
              <input
                type="radio"
                name="filter-type"
                value="rental"
                checked={adType === "rental"}
                onChange={(e) => onAdTypeChange(e.target.value)}
              />
              <span className="custom-radio"></span>
              <span className="type-tag rental">Rental</span>
              <span className="type-count">({rentCount})</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFilter;
